import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const getCounters = async (query) => {
  return await httpClient.get(`postcontractual_followup/counters${query}`);
};

const getProjects = async (params) => {
  return await httpClient.get('/postcontractual_followup_selectors/projects/', {
    params: params,
  });
};

const getPriorities = async (params) => {
  return await httpClient.get(
    '/postcontractual_followup_selectors/priorities/',
    {
      params: params,
    },
  );
};

const getRoles = async (params) => {
  return await httpClient.get('/postcontractual_followup_selectors/roles/', {
    params: params,
  });
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `/postcontractual_followup/export${query}${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/postcontractual_followup${query}&page[number]=${page}&page[size]=${pageSize}${searchBy}`,
    );
};

const annulate = async (id, data) => {
  return await httpClient.delete(`/postcontractual_followup/${id}/`, { data });
};

const sendUnilateral = async (id) => {
  return await httpClient.patch(
    `/postcontractual_followup/${id}/send_unilateral/`,
  );
};

const getEdit = async (id) => {
  return await httpClient.get(`/postcontractual_followup_edition/${id}/`);
};

const putEdit = async (id, data) => {
  return await httpClient.put(`/postcontractual_followup_edition/${id}/`, data);
};

const previewActEdit = async (id, data) =>
  await httpClient.patch(
    `/postcontractual_followup_edition/${id}/preview/`,
    data,
  );

export {
  getProjects,
  getPriorities,
  getRoles,
  getCounters,
  ajaxTable,
  annulate,
  sendUnilateral,
  getEdit,
  putEdit,
  previewActEdit,
};
